import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const benefits = (theme: Theme) => css`
  background: ${theme.palette.primary.lowContrast};
  padding-top: ${size[64]};
  padding-bottom: ${size[20]};
  margin-top: ${size[64]};
  position: relative;

  ${breakpoint.up('smMd')} {
    padding-top: ${size[160]};
    padding-bottom: ${size[160]};
    margin-top: ${size[112]};
  }
`

export const container = css`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 0 auto;
  padding: 0 ${size[20]};
  max-width: ${width.container.large};

  ${breakpoint.up('smMd')} {
    gap: ${size[32]};
    flex-direction: row;
  }
`

export const main = css`
  margin: ${size[32]} 0;

  ${breakpoint.up('smMd')} {
    max-width: 60%;
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  gap: ${size[16]};

  & a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    max-width: 33rem;
    gap: ${size[24]};
    flex-direction: row;
  }
`

export const media = css`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpoint.up('smMd')} {
    max-width: 44%;
  }

  video {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    display: block;
    clip-path: inset(2px 2px);
  }

  picture {
    flex-grow: 1;
  }

  img {
    margin: auto;
    display: block;
    width: 100%;
    height: auto;
    isolation: isolate;
  }
`

export const widget = css`
  position: absolute;
  right: 0;
  left: 22%;
  bottom: 5%;
`
